<script setup lang="ts">
const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: 'var(--sds-color-icon-primary-default)',
  },
  direction: {
    type: String,
    default: 'down',
  },
})
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    :style="{
      transform:
        props.direction === 'up'
          ? 'rotate(180deg)'
          : props.direction === 'right'
            ? 'rotate(-90deg)'
            : props.direction === 'down'
              ? 'none'
              : 'rotate(90deg)',
    }"
  >
    <path
      d="M4 6L8 10L12 6"
      :stroke="props.active ? 'var(--sds-color-icon-brand-green)' : props.color"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped>
svg {
  transition: transform 0.4s ease-in-out;
}
</style>
